import Link from 'next/link'
import React from 'react'
import designerArrow from '@/assets/img/footer/designer-arrow.svg'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { usePathname } from 'next/navigation'

const FooterBottom = () => {
    const { t } = useTranslation()
    const pathname = usePathname()

    return (
        <div className='footer__bottom-content'>
            <div className='footer__bottom-lists'>
                <ul className='footer__bottom-list'>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/about-us'
                            className='footer__bottom-link'
                        >
                            {t('megamixB2B')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/for-farmers'
                            className='footer__bottom-link'
                        >
                            {t('megamixForFarmers')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/consulting'
                            className='footer__bottom-link'
                        >
                            {t('consulting')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/products'
                            className='footer__bottom-link'
                        >
                            {t('products')}
                        </Link>
                    </li>
                </ul>
                <ul className='footer__bottom-list'>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/labs'
                            className='footer__bottom-link'
                        >
                            {t('laboratories')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='trading'
                            className='footer__bottom-link'
                        >
                            {t('trading')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='export'
                            className='footer__bottom-link'
                        >
                            {t('export')}
                        </Link>
                    </li>
                </ul>
                <ul className='footer__bottom-list'>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/news'
                            className='footer__bottom-link'
                        >
                            {t('newsTitle')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/useful-materials'
                            className='footer__bottom-link'
                        >
                            {t('usefulMaterialsTitle')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/catalog'
                            className='footer__bottom-link'
                        >
                            {t('catalog')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/vacancy'
                            className='footer__bottom-link'
                        >
                            {t('vacancy')}
                        </Link>
                    </li>
                </ul>
                <ul className='footer__bottom-list'>
                    <li className='footer__bottom-item'>
                        <Link
                            


                            target={"_blank"}








                            href='/Сертификат_соответствия_требованиям_ГОСТ_Р_ИСО_45001_2020_ISO_45001.pdf'
                            className='footer__bottom-link'
                        >
                            {t('LegalInformation')}
                        </Link>
                    </li>
                    <li className='footer__bottom-item'>
                        <Link
                            href='/confidential'
                            className='footer__bottom-link'
                        >
                            {t('PersonalDataProcessing')}
                        </Link>
                    </li>
                    {pathname === '/school' && (
                        <li className='footer__bottom-item'>
                            <Link
                                target='_blank'
                                href='/ПРАВИЛА_ПРОВЕДЕНИЯ_СТИМУЛИРУЮЩЕГО_МЕРОПРИЯТИЯ_МЕГА_ПАРТНЕР_2026.docx'
                                className='footer__bottom-link'
                            >
                                Правила проведения стимулирующего мероприятия «Мега Партнер 2026»
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
            <div className='footer__address'>
                <p className='footer__address-text'>Адрес: 400123, Волгоград, ул. Хрустальная, 107, оф.1</p>
                <p className='footer__address-text'>© {new Date().getFullYear()} ООО «МегаМикс» </p>
                <div className='footer__designer-link'>
                    <p>Сделано в </p>
                    <a
                        href='https://chebe.digital'
                        target='_blank'
                    >
                        ЧеБэ
                        <svg
                            width='8'
                            height='8'
                            viewBox='0 0 8 8'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M7.25685 1.00037C7.25685 0.669001 6.98823 0.400372 6.65685 0.400372L1.25685 0.400372C0.925483 0.400372 0.656854 0.669001 0.656854 1.00037C0.656854 1.33174 0.925483 1.60037 1.25685 1.60037L6.05685 1.60037L6.05685 6.40037C6.05685 6.73174 6.32548 7.00037 6.65685 7.00037C6.98823 7.00037 7.25685 6.73174 7.25685 6.40037L7.25685 1.00037ZM0.575736 6.23296C0.341421 6.46728 0.341421 6.84718 0.575736 7.08149C0.810051 7.31581 1.18995 7.31581 1.42426 7.08149L0.575736 6.23296ZM1.42426 7.08149L7.08112 1.42464L6.23259 0.576108L0.575736 6.23296L1.42426 7.08149Z'
                                fill='#83a3eb'
                            />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default FooterBottom
